import { Router } from 'react-router-dom';
export * from 'react-router-dom';
export const ReactRouter = Router;
